<ng-container *ngIf="icons">
  <i class="fa fa-2x {{icons[value]}}" style="color: #33c033" aria-hidden="true"></i>
</ng-container>
<ng-container *ngIf="!icons">
  <span *ngIf="type === 'choice' || (type === 'field' && choices !== undefined)">{{ value | display:choices }}</span>
  <span *ngIf="type === 'datetime'">{{ value | date:'short' }}</span>
  <span *ngIf="type === 'url'"><a [href]="value" target="_blank">Click Here</a></span>
  <span *ngIf="(type === 'email') && !allowLong && value" [ngbTooltip]="value"
        [disableTooltip]="value.length < 35" onclick="event.stopPropagation()">
  <a href="mailto:{{value}}" target="_blank">{{ value | limitTo: 35 }}<b>{{ value.length > 35 ? '...' : '' }}</b></a>

</span>
  <span *ngIf="(type === 'string') && !allowLong && value" [ngbTooltip]="value"
        [disableTooltip]="value.length < 35">
  {{ value | limitTo: 35 }}<b>{{ value.length > 35 ? '...' : '' }}</b>

</span>
  <span *ngIf="type === 'string' && allowLong" style="white-space: pre-line;">{{ value }}</span>

  <span *ngIf="type === 'phone_number'">
    {{ value | phoneNumber }}
</span>
  <span *ngIf="type === 'decimal' || type === 'float' || type === 'integer' || type === 'decimal'">
    {{ value | toString }}
</span>
  <span *ngIf="type === 'field' && choices === undefined && !loading" style="white-space: pre-line;">{{ value }}</span>
  <i class="fa fa-spinner fa-pulse" *ngIf="loading"></i>
  <span *ngIf="type === 'boolean'">{{ value | display:'boolean' }}</span>
  <span *ngIf="type === 'multiple choice' || type === 'multiple'">
    <span *ngFor="let v of value; index as i;">{{ v | display:choices }}<span
        *ngIf="i+1 !== value.length">, </span></span>
</span>
  <span *ngIf="type === 'attachment' && value !== null" style="display: flex; flex-direction: column; align-items: flex-start">
    <a (click)="$event.stopPropagation()" *ngIf="downloadUrl" [href]="downloadUrl" target="_blank">{{ value.filename }}</a>
    <span *ngIf="!downloadUrl">{{ value.filename }}</span>
    <img
        *ngIf="value?.content_type !== undefined && (value?.content_type | isImage) && value?.data !== undefined"
        style="max-height:350px"
        [src]="allowBase64('data:'+value?.content_type+';base64,'+value?.data)"/>
        <img
            *ngIf="value?.filetype !== undefined && (value?.filetype | isImage) && value?.base64 !== undefined"
            style="max-height:350px"
            [src]="allowBase64('data:'+value?.filetype+';base64,'+value?.base64)"/>
</span>

  <span *ngIf="type === 'nested object'">{{ value.display_name }}</span>
  <span *ngIf="type === 'many'"><span style="white-space: nowrap" *ngFor="let v of value">{{ v | display:choices }}
    <br></span></span>
</ng-container>
